/*       */
import React from 'react';

import Help from 'app/utils/designer/form/settings/common/Help';
import { name, label } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { required, readOnly, classRequired } from 'app/utils/designer/form/settings/common/commonValidation';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';
import RadioGroupValues from 'app/components/Designer/RadioGroupValues/RadioGroupValues';

const displayMode = {
    type: 'typeahead',
    properties: {
        name: 'properties.displayMode',
        label: 'Display mode',
        options: [
            { value: 'radio', label: 'Radio buttons' },
            { value: 'checkbox', label: 'Checkboxes' },
            { value: 'dropdown', label: 'Dropdown' },
        ],
        clearable: false,
        help: <Help message="Choose how the options will be displayed" />,
        defaultValue: 'radio',
    },
};

const helperText = {
    type: 'text',
    properties: {
        label: 'Helper text',
        name: 'properties.helperText',
        help: <Help message="Helper text displayed below the component" />,
    },
};

const panels = settingsValues => [
    {
        header: 'Base',
        children: [name, displayMode, label, helperText],
    },
    {
        header: 'Values',
        expanded: true,
        children: [
            {
                type: 'custom',
                properties: {
                    name: 'properties.options',
                    Component: RadioGroupValues,
                    help: (
                        <Help
                            message={`Define the options with value, label, helper text and icon.

Each option should have:
- **Value**: Unique identifier (required)
- **Label**: Display text (required)
- **Helper text**: Additional information (optional, radio/checkbox only)
- **Icon**: Icon name (optional)

**CSV Format (Raw mode):**
\`\`\`
value,label,helper text,icon name,icon type
house,House
apartment,Apartment,Additional information
garage,Garage,,home,mdi
office,Office,,entities,af
\`\`\`
`}
                        />
                    ),
                },
            },
        ],
    },
    {
        header: 'Events',
        children: [onLoad, onChange, isVisible, settingsValues?.viewType !== 'class' && isDisabled].filter(Boolean),
    },
    {
        header: 'Validation',
        children: [
            settingsValues?.viewType !== 'class' ? required : classRequired,
            settingsValues?.viewType === 'class' && readOnly,
        ].filter(Boolean),
    },
    {
        header: 'Styles',
        children: [flexGrow],
    },
    {
        header: 'Helpers',
        children: [help],
    },
];

export default {
    defaults: { withDefault: true, serialize: true },
    panels: settingValues => panels(settingValues),
};
